module.exports = __webpack_public_path__ + "static/media/0_2019_07_02.2db4a62b.jpg";